<template>
    <div class="theme-select">
        <div
            :style="{
                background: this.colorBlockStyle
            }"
            :class="{
                'theme-active': active,
                'theme-plate': true
            }"
            @click="onSelectTheme(theme)"
        ></div>
        <div
            v-if="canRemoveTheme"
            @click="active && !allowRemove ? null : onRemoveTheme(theme)"
            :class="{ 'remove-theme': true, 'disable-remove': active && !allowRemove }"
        >
            <i class="fas fa-times" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        theme: {
            type: Object
        },
        active: {
            type: Boolean
        },
        allowRemove: {
            type: Boolean,
            default: false
        },
        isBackend: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        canRemoveTheme() {
            if (this.allowRemove) {
                return true
            }

            const disallowedThemes = ['theme_1', 'theme_2', 'theme_3']
            return !disallowedThemes.includes(this.theme.name) && !this.theme.is_system
        },

        colorBlockStyle() {
            if (this.isBackend) {
                return `linear-gradient(45deg, ${this.theme.ui_color}, ${this.theme.ui_color}),
                    linear-gradient(135deg, ${this.theme.background_color}, ${this.theme.background_color}),
                    linear-gradient(225deg, ${this.theme.question_text_color}, ${this.theme.question_text_color}),
                    linear-gradient(225deg, ${this.theme.button_color}, ${this.theme.button_color})`
            }

            return `linear-gradient(45deg, ${this.theme.question_text_color}, ${this.theme.question_text_color}),
                linear-gradient(135deg, ${this.theme.button_text_color}, ${this.theme.button_text_color}),
                linear-gradient(225deg, ${this.theme.background_color}, ${this.theme.background_color}),
                linear-gradient(225deg, ${this.theme.button_color}, ${this.theme.button_color})`
        }
    },

    methods: {
        onSelectTheme(theme) {
            this.$emit('select', theme)
        },

        onRemoveTheme(theme) {
            this.$emit('remove', theme)
        }
    }
}
</script>

<style lang="scss">
.theme-select {
    position: relative;

    .theme-plate {
        width: 66px;
        height: 66px;
        background-size: 50% 50% !important;
        background-position: 0% 0%, 0% 100%, 100% 0%, 100% 100% !important;
        background-repeat: no-repeat !important;
        border-radius: 50%;
        border: 3px solid #919191;
        transition: transform 200ms ease-out 0s;
        cursor: pointer;

        &:hover {
            transform: scale(1.1);
        }

        &.theme-active {
            border: 4px solid #28a745;
        }
    }

    .remove-theme {
        cursor: pointer;
        display: flex;
        position: absolute;
        justify-content: center;
        align-items: center;
        top: -7px;
        right: -4px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #000;

        i {
            color: #fff;
            font-size: 16px;
        }
    }

    .disable-remove {
        cursor: not-allowed;
        background-color: rgba(94, 94, 94, 0.192);
    }
}
</style>
